export const ApiErrorInitialState = {
    error: '',
    error_code: 0,
};
